import styled from 'styled-components'
import { CssUnit } from '@/types'
import { toUnit } from '@/utils/styles'

type BoxProps = {
  display?: string
  justify?: string
  align?: string
  gap?: string
  direction?: string
  height?: CssUnit
  maxWidth?: CssUnit
  width?: CssUnit
  ptop?: CssUnit
  pbottom?: CssUnit
  pleft?: CssUnit
  pright?: CssUnit
  top?: CssUnit
  bottom?: CssUnit
  left?: CssUnit
  right?: CssUnit
  color?: string
  textAlign?: string
}

const Box = styled.div.withConfig<BoxProps>({
  shouldForwardProp: (prop, defaultValidatorFn) =>
    !['display', 'height', 'width', 'maxWidth', 'gap', 'color', 'direction'].includes(prop) &&
    defaultValidatorFn(prop)
})`
  padding-top: ${({ ptop }) => toUnit(ptop || 0)};
  padding-bottom: ${({ pbottom }) => toUnit(pbottom || 0)};
  padding-left: ${({ pleft }) => toUnit(pleft || 0)};
  padding-right: ${({ pright }) => toUnit(pright || 0)};
  margin-top: ${({ top }) => toUnit(top || 0)};
  margin-bottom: ${({ bottom }) => toUnit(bottom || 0)};
  margin-left: ${({ left }) => toUnit(left || 0)};
  margin-right: ${({ right }) => toUnit(right || 0)};
  display: ${({ display }) => display || 'flex'};
  justify-content: ${({ justify }) => justify || 'flex-start'};
  flex-direction: ${({ direction }) => direction || 'row'};
  min-width: 0;
  height: ${({ height }) => toUnit(height || 'unset')};
  width: ${({ width }) => toUnit(width || 'unset')};
  max-width: ${({ maxWidth }) => toUnit(maxWidth || 'unset')};
  color: ${({ color }) => color || 'inherit'};
  text-align: ${({ textAlign }) => textAlign || 'inherit'};
  gap: ${({ gap }) => gap || 'unset'};
  align-items: ${({ align }) => align || 'normal'};
`

export default Box
